import React, { useState, useEffect } from 'react'
import { NavLink } from 'react-router-dom'
import { routersHelper, IconHelper, logoutByUser } from '../helpers'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import i18n from '../i18n'
import { SET_LANGUAGE } from '../redux/actions/type'
import { isEmpty } from 'lodash'
import { login, charectorLength, setCookie } from '../helpers'

const Header = ({ getKeycloak, getAuthenticated, t, switchLanguage, language, contextInfo }) => {
    const { useRouter } = routersHelper
    const router = useRouter()
    const { pathname } = router
    const [keycloak, setKeycloak] = useState(null)
    const [authenticated, setAuthenticated] = useState(false)
    const [context, setContext] = useState({
        avatar: '',
        name: '',
        p: '',
        pkgcode: '',
    })
    const { IconTH, IconEN, IconCN } = IconHelper

    if (pathname.indexOf("/prepare") >= 0) {
        document.body.style.overflow = "hidden"
    } else {
        document.body.style.overflow = "auto"
    }

    useEffect(() => {
        if (authenticated && !isEmpty(keycloak)) {
            setContext({
                ...contextInfo,
                name: contextInfo.name.split(" ")[0] || ''
            })
        }
        setKeycloak(getKeycloak)
        setAuthenticated(getAuthenticated)
    }, [setKeycloak,
        setAuthenticated,
        getKeycloak,
        getAuthenticated,
        keycloak,
        authenticated,
        setContext,
        contextInfo
    ])

    const logout = () => {
        logoutByUser(keycloak)
    }

    const leftMenuOpen = () => {
        const leftMenu = document.getElementsByClassName('leftMenu')[0];
        const bgBlack = document.getElementsByClassName('bgBlack')[0];
        // document.body.style.overflow = 'hidden'
        leftMenu.style.left = '0px'
        bgBlack.style.height = `${window.innerHeight}px`
        bgBlack.style.display = 'block'
    }

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng)
        setCookie('language', lng)
        switchLanguage(lng)
    }
    const initialLanguage = { overflow: 'initial', top: '-5px', cursor: 'pointer' }
    return (
        <div className="nav">
            <div id="nav">
                <div className="logo">
                    <svg className="icon-ham" onClick={leftMenuOpen} aria-hidden="true" focusable="false" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 1024 1024">
                        <path id="icon-ham" d="M904 160H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0 624H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0-312H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8z" fill="#626262" />
                    </svg>
                    <NavLink exact to="/portal" activeClassName="active">
                        {/* eslint-disable-next-line */}
                        <img src={process.env.PUBLIC_URL + '/img/logo.svg'} />
                    </NavLink>
                </div>
                <div className="menu">
                    <ul>
                        <li>
                            <a href={`${window._env_.vRoomUrl}/portal`}>{t("menu_home")}</a>
                        </li>
                        {
                            authenticated
                                ? <li>
                                    <a href={window._env_.mymeeting}>{t("menu_reservation")}</a>
                                </li>
                                : null
                        }
                        {
                            parseInt(window._env_.isShowPlanPrice) === 1 ? (
                                <li>
                                    <a href={window._env_.subscriptionPlanspricing}>{t("menu_price")}</a>
                                </li>
                            ) : null
                        }
                        <li>
                            <a href={window._env_.SUPPORT_WEB}>{t("menu_support")}</a>
                        </li>
                        {
                            parseInt(window._env_.isShowContactPage) === 1
                                ? (<li>
                                    {/* <NavLink exact to="/portal/contact" activeclassname="">
                                                      
                                                        {t("menu_contact_page")}
                                                    </NavLink> */}
                                    <a href={`${window._env_.vRoomUrl}/portal/contact`}>{t("menu_contact_page")}</a>
                                </li>
                                ) : null
                        }
                        {/* <li>
                            <NavLink exact to="/portal/package" activeClassName="active">{t("menu_package")}</NavLink>
                        </li> */}
                        {
                            authenticated ? (
                                <li className="sub-menu">
                                    {/* eslint-disable-next-line */}
                                    <a href="#">
                                        {context.name.length > 15 ?
                                            <>{`${t("menu_greet")} ${charectorLength(context.name)}`}</>
                                            :
                                            <>{`${t("menu_greet")} ${context.name}`}</>
                                        }
                                        {/* {`${t("menu_greet")} ${context.name}`} */}
                                    </a>
                                    <div className="menu">
                                        <ul>
                                            <li className="dropdown-content">
                                                {/* eslint-disable-next-line */}
                                                <a href={`${window._env_.vRoomUrl}/portal/profile`}>
                                                    {t("menu_profile")}
                                                </a>
                                                <a href="/portal/myrecords">
                                                    {t("menu_my_records")}
                                                </a>
                                                {/* eslint-disable-next-line */}
                                                <a href="#" onClick={logout}>
                                                    {t("menu_logout")}
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                            ) : (
                                <li>
                                    {/* eslint-disable-next-line */}
                                    <a href="#" onClick={login.bind(this, keycloak, language)}>
                                        {t("menu_login")}
                                    </a>
                                </li>
                            )
                        }
                        <li className="icon-language">
                            <IconTH
                                width="20"
                                height="20"
                                style={
                                    language === 'th' ? { ...initialLanguage } : { filter: 'grayscale(1)', ...initialLanguage }
                                }
                                onClick={changeLanguage.bind(this, 'th')} />
                            <IconEN
                                width="20"
                                height="20"
                                style={
                                    language === 'en' ? { ...initialLanguage } : { filter: 'grayscale(1)', ...initialLanguage }
                                }
                                onClick={changeLanguage.bind(this, 'en')} />
                            <IconCN
                                width="20"
                                height="20"
                                style={
                                    language === 'cn' ? { ...initialLanguage } : { filter: 'grayscale(1)', ...initialLanguage }
                                }
                                onClick={changeLanguage.bind(this, 'cn')} />
                        </li>
                    </ul>
                </div>
            </div>
        </div >
    )
}

const mapStateToProps = state => ({
    getKeycloak: state.keycloak,
    getAuthenticated: state.keycloak.authenticated,
    language: state.language,
    contextInfo: state.contextInfo
})

const mapDispatchToProps = dispatch => ({
    switchLanguage: (lang) => {
        dispatch({
            type: SET_LANGUAGE,
            payload: lang
        })
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(translate()(Header))